import { render, staticRenderFns } from "./WarningBanner.vue?vue&type=template&id=66e00dc7&scoped=true"
import script from "./WarningBanner.vue?vue&type=script&lang=js"
export * from "./WarningBanner.vue?vue&type=script&lang=js"
import style0 from "./WarningBanner.vue?vue&type=style&index=0&id=66e00dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e00dc7",
  null
  
)

export default component.exports